import React from 'react';

import { AddIssueTypeButton } from '@qality/common-pages/src/Dashboard/AddIssueTypeButton';

import {
  GadgetExplanationText,
  GadgetLink,
  GedgetConfigStyled,
} from '../gadgets.styled';

const TestExecutionGadgetConfigView: React.FC = () => {
  return (
    <GedgetConfigStyled>
      <GadgetExplanationText>
        You will have easy access to your recently executed Test cases, as soon
        as Jira Administrator adds the QAlity Test issue type to project.
      </GadgetExplanationText>
      <div>
        <AddIssueTypeButton />
        <GadgetLink onClick={() => window.open(plugin.quickStartUrl, '_blank')}>
          Find out how to do it
        </GadgetLink>
      </div>
    </GedgetConfigStyled>
  );
};

export default TestExecutionGadgetConfigView;
